/* eslint-disable react-hooks/rules-of-hooks */
import { notification } from "antd";
import { create } from "apisauce";
import axios from "axios";

// Adicione um interceptor para incluir o cabeçalho Authorization em todas as requisições
const token = localStorage.getItem("token");

const axiosCreateApi = axios.create({
  baseURL: "https://apifsjus.vercel.app/",
  // baseURL: "http://localhost:3001/",
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

const api = create({
  axiosInstance: axiosCreateApi,
  disableNotification: true,
} as any);

// if (token) {
//   api.defaults.headers.Authorization = `Bearer ${token}`;
// }

api.addResponseTransform((response) => {
  if (response.status === 403) {
    localStorage.removeItem("token");
    window.location.href = "/login";
    notification.error({
      message: "Erro!",
      description: `Tempo de sessão expirado, faça o login novamente!`,
      placement: "topRight",
      duration: 5,
    });
  } else if (response.status === 500) {
    notification.error({
      message: "Erro!",
      description: `Erro ${response.status}: ${response.data.error}`,
      placement: "topRight",
      duration: 5,
    });
  }
});

export default api;
